export default __webpack_public_path__ + "889a5fa38dd50839b4b0a7242785df86.svg";